import React from "react";
import Spacer2 from "../Components/common/Spacer2";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import ProductSimilarCamasirsulari from "../Components/similar/ProductSimilarCamasirsulari";
import SEO from "../Components/common/SEO";

function ProductSimilarCamasirsulariPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/ProductSimilarCamasirsulari`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    'name': 'Çamaşır Suları',
    'url': pageUrl,
    'mainEntity': {
      '@type': 'ItemList',
      'name': 'Çamaşır Suları',
      'itemListElement': [
        { '@type': 'Product', 'name': 'Çamaşır Suyu', 'url': `${siteUrl}/camasirsuyu` },
        { '@type': 'Product', 'name': 'Ultra Kıvamlı Ç. Suyu', 'url': `${siteUrl}/ultrakivamlicamasirsuyu` }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Çamaşır Suları | Seymen Kimya"
        description="Çamaşır suyu serisini inceleyin: standart ve ultra kıvamlı seçenekler."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/20-kg/2.webp`}
        structuredData={structuredData}
      />
      <PageHeader title={t("ÇAMAŞIR SULARI")} />
      <Spacer2 />
      <ProductSimilarCamasirsulari />
    </>
  );
}

export default ProductSimilarCamasirsulariPage;
